// SlideDeckPlayer — Phase 2 / Step C-3.3 Pass 2 shim. See
// shared/widgets/scenario_os/SlideDeckPlayer.jsx for the canonical
// implementation. The shared widget takes `slideDeckAPI` as a prop
// (so Atlas Catalog previews don't drag in the learner-app axios
// instance); this shim binds the learner-app singleton so SessionPage
// + TutorialPlayerPage call sites continue working unchanged.
import React from 'react';
import { slideDeckAPI } from '../../services/api';
import SlideDeckPlayerShared from '../../../../shared/widgets/scenario_os/SlideDeckPlayer.jsx';

export default function SlideDeckPlayer(props) {
  return <SlideDeckPlayerShared slideDeckAPI={slideDeckAPI} {...props} />;
}
